import * as React from "react"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import LazyVideo from "@/components/LazyVideo"
import G2Stars from "@/components/svg/G2StarsOrange"
import { gtmTracking } from "@/utils/gtm-tracking"
import isExternalLink from "@/utils/is-external-link"

const TwoColumnHero = ({
  kicker,
  title,
  titleClass,
  description,
  scrollToPricingSection,
  image,
  g2StarsKicker = false,
  video,
  button,
  children,
  childrenColumn = false,
  className = "",
  loop = false,
}) => {
  const { t } = useTranslation()

  return (
    <section className={`container-fluid two-column-hero ${className}`}>
      <div className="two-column-hero__content">
        <div className="col-xs-12">
          {g2StarsKicker && (
            <div className="g2-rating">
              <G2Stars />
              <span className="g2-rating--text">
                {t("home.header.g2-rating")}
              </span>
            </div>
          )}
          {kicker && (
            <h1 className="heading-kicker heading-kicker--no-status">
              {kicker}
            </h1>
          )}
          {!kicker && <h1 className={titleClass}>{title}</h1>}
          {kicker && <span className={`${titleClass || "h1"}`}>{title}</span>}
        </div>
        {description &&
          (typeof description === "string" ? (
            <p className="two-column-hero__description">{description}</p>
          ) : (
            <div className="two-column-hero__description">{description}</div>
          ))}
        <div
          className={`two-column-hero__children ${childrenColumn ? "two-column-hero__children-column" : ""}`}
        >
          {scrollToPricingSection ? (
            <button
              onClick={() => {
                gtmTracking(
                  "CTA Click",
                  scrollToPricingSection.text,
                  "Two Column Hero",
                )()
                const pricingSection = document.getElementById(
                  scrollToPricingSection.id,
                )

                if (pricingSection) {
                  pricingSection.scrollIntoView({ behavior: "smooth" })
                }
              }}
              className="btn"
            >
              {scrollToPricingSection.text}
            </button>
          ) : (
            button &&
            (button.onClick ? (
              <button
                type="button"
                className="btn"
                onClick={() => {
                  gtmTracking("CTA Click", button.text, "Two Column Hero")()
                  button.onClick()
                }}
              >
                {button.text}
              </button>
            ) : isExternalLink(button.link) ? (
              <a
                href={button.link}
                className="btn"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  gtmTracking("CTA Click", button.text, "Two Column Hero")()
                }
              >
                {button.text}
              </a>
            ) : (
              <Link
                to={button.link}
                className="btn"
                onClick={() =>
                  gtmTracking("CTA Click", button.text, "Two Column Hero")()
                }
              >
                {button.text}
              </Link>
            ))
          )}
          {children}
        </div>
      </div>

      {image && (
        <div className="two-column-hero__image">
          <GatsbyImage image={getImage(image.src)} alt={image.alt} />
        </div>
      )}
      {video && (
        <div className="two-column-hero__video">
          <LazyVideo
            video={video.file}
            fallback={video.fallback}
            loop={video.loop ?? loop}
            width={video.width}
          />
        </div>
      )}
    </section>
  )
}

export default TwoColumnHero
